<div class="container">

    <app-section-header
    [sectionTitle]="blockTitle"
    [arrows]="true"
    (next)="carousel.next()"
    (prev)="carousel.prev()"
    (changeGroup)="changeGroup.emit($any($event))"
></app-section-header>

    <div
        *ngIf="showCarousel"
        class="block-products-carousel__carousel"
        [class.block-products-carousel__carousel--loading]="isLoading"
        [class.block-products-carousel__carousel--has-items]="data?.length > 0"
    >
        <div class="block-products-carousel__carousel-loader"></div>

        <owl-carousel-o [options]="carouselOptions" appOwlPreventClick>
            <ng-template *ngFor="let product of data" carouselSlide>
                <div class="block-products-carousel__column">
                    <app-product-card
                        class="block-products-carousel__cell"
                        [product]="product"
                        [layout]="productCardLayout"
                        [exclude]="productCardExclude"
                    ></app-product-card>
                </div>
            </ng-template>
        </owl-carousel-o>
    </div>
</div>
